// https://www.folkstalk.com/2022/09/how-to-decode-jwt-token-client-side-with-code-examples.html
// TODO: see if there is a better way....

export const b64Decode = (str) =>
  decodeURIComponent(
    Array.prototype.map
      .call(
        atob(str),
        (c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
      )
      .join("")
  );
